import type { ReactNode } from 'react';

import { LogoIcon, Page, PageContent } from '@truvhq/ui';
import PerfectScrollbar from 'react-perfect-scrollbar';

import backgroundImage from '../../assets/images/right_background.png';
import { Footer } from './Footer';

type AuthLayoutTemplateProps = {
  children: ReactNode;
  showLogo?: boolean;
  logoWidth?: number;
  pageName?: string;
};

export const AuthLayoutTemplate = ({
  children,
  showLogo = true,
  logoWidth = 74,
  pageName = '',
}: AuthLayoutTemplateProps) => {
  return (
    <Page className="flex h-full !flex-row">
      <PageContent fullscreen className="flex">
        <div className="flex-1 px-8">
          <PerfectScrollbar className="flex flex-col">
            {showLogo && <LogoIcon className="mx-8 mt-8 shrink-0" width={logoWidth} />}
            <div className="m-8 flex flex-grow flex-col items-center justify-center">
              <div className="w-full max-w-[536px]">{children}</div>
            </div>
            <Footer pageName={pageName} />
          </PerfectScrollbar>
        </div>

        <img alt="dashboard preview" className="h-full object-cover" src={backgroundImage} />
      </PageContent>
    </Page>
  );
};
